import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { BellRing } from 'lucide-react';
import { useAnnouncements, ANNOUNCEMENTS_PATH } from '../../context/AnnouncementsProvider';
import styles from './AnnouncementToast.module.css';

const VISIBLE_MS = 6000;

function AnnouncementToast() {
  const { toast, dismissToast } = useAnnouncements();
  const navigate = useNavigate();

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(dismissToast, VISIBLE_MS);
    return () => clearTimeout(timer);
  }, [toast, dismissToast]);

  if (!toast) return null;

  return (
    <button
      /* Keyed on the announcement so a second one arriving mid-countdown
         remounts the toast and restarts the progress bar from full. */
      key={toast.id}
      type="button"
      className={styles.toast}
      onClick={() => { dismissToast(); navigate(ANNOUNCEMENTS_PATH); }}
    >
      <span className={styles.label}>
        <BellRing size={17} />
        New announcement
      </span>
      <span className={styles.track}>
        <span className={styles.progress} style={{ animationDuration: `${VISIBLE_MS}ms` }} />
      </span>
    </button>
  );
}

export default AnnouncementToast;
